export default __webpack_public_path__ + "static/media/03-healthcare_thumb.6ad518c5.png";